
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leads/embed/[leadEmbedId]",
      function () {
        return require("private-next-pages/leads/embed/[leadEmbedId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leads/embed/[leadEmbedId]"])
      });
    }
  